import { render, staticRenderFns } from "./cancelLogs.vue?vue&type=template&id=06b05e92&"
import script from "./cancelLogs.vue?vue&type=script&lang=js&"
export * from "./cancelLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports